import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr/fr";
import en from "./en/en";
import es from "./es/es";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
    es: {
      translation: es,
    },
  },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
